<template>
  <div class="overlay_warpper">
    <div class="overlay_body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.overlay_warpper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.3);
  z-index: 3000;
}
.overlay_body {
  width: 100%;
  height: 100%;
}
</style>
